module.exports = __webpack_public_path__ + "static/media/infrastructure.2988a564.png";